var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorGeneral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 83
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.579,
    cy: 18.062,
    r: 17.859,
    fill: "#FF007B",
    transform: "translate(52 47)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#2C3543"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.662 54.488c-2.502-.003-4.53-2.042-4.533-4.56V26.647c0-2.52 2.03-4.562 4.533-4.562 2.504 0 4.533 2.042 4.533 4.562v23.281c-.004 2.518-2.031 4.557-4.533 4.56zm0-30.667a2.822 2.822 0 00-2.808 2.826v23.281a2.817 2.817 0 002.808 2.826 2.817 2.817 0 002.808-2.826V26.647a2.822 2.822 0 00-2.808-2.826zm.002 41.34a4.515 4.515 0 01-4.173-2.803 4.564 4.564 0 01.978-4.952 4.495 4.495 0 014.922-.985 4.543 4.543 0 012.786 4.2c-.003 2.506-2.022 4.537-4.513 4.54zm0-7.348a2.79 2.79 0 00-2.579 1.732 2.82 2.82 0 00.603 3.06 2.777 2.777 0 003.041.61 2.807 2.807 0 001.723-2.595 2.8 2.8 0 00-2.788-2.807z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.977 80.505H8.347a8.33 8.33 0 01-7.222-4.196 8.437 8.437 0 010-8.392L37.44 4.63A8.25 8.25 0 0144.662.435a8.246 8.246 0 017.222 4.194L88.2 67.919a8.44 8.44 0 01-.003 8.392 8.331 8.331 0 01-7.221 4.196v-.002zM44.662 2.168a6.543 6.543 0 00-5.73 3.326L2.619 68.785a6.692 6.692 0 000 6.656 6.608 6.608 0 005.73 3.328h72.629a6.608 6.608 0 005.729-3.328 6.692 6.692 0 000-6.656L50.39 5.495a6.541 6.541 0 00-5.727-3.327h-.002z"
  })))));
}
export default SvgErrorGeneral;